import type { PayloadAction } from '@reduxjs/toolkit';
import type { ConfiguredAddOn, ConfiguredService } from '@features/service-plans/types/services.types';
import type { QuoteData } from '../types/quote.types';
import { refreshAnchor, type AnchorMeta } from '../utils/basketDates';
import { todayDateKey, type DateKey } from '../utils/dateKey';

interface DerivedSchedule {
    services: QuoteData['configuredServices'];
    addOns: QuoteData['configuredAddOns'];
}

export const basketReducers = {
    setConfiguredServices: {
        reducer: (state: QuoteData, action: PayloadAction<ConfiguredService[], string, AnchorMeta>) => {
            refreshAnchor(state, { services: action.payload }, action.meta);
            state.configuredServices = action.payload;
        },
        prepare: (services: ConfiguredService[]) => ({
            payload: services,
            meta: { today: todayDateKey() },
        }),
    },

    setConfiguredAddOns: {
        reducer: (state: QuoteData, action: PayloadAction<ConfiguredAddOn[], string, AnchorMeta>) => {
            refreshAnchor(state, { addOns: action.payload }, action.meta);
            state.configuredAddOns = action.payload;
        },
        prepare: (addOns: ConfiguredAddOn[]) => ({
            payload: addOns,
            meta: { today: todayDateKey() },
        }),
    },

    setAnchorDate: (state: QuoteData, action: PayloadAction<DateKey | null>) => {
        state.anchorDate = action.payload;
    },

    // One reducer writes both lists, so a linked add-on can never be
    // observed against a service row list it was not re-keyed for.
    applyDerivedSchedule: {
        reducer: (state: QuoteData, action: PayloadAction<DerivedSchedule, string, AnchorMeta>) => {
            refreshAnchor(state, action.payload, action.meta);
            state.configuredServices = action.payload.services;
            state.configuredAddOns = action.payload.addOns;
        },
        prepare: (schedule: DerivedSchedule) => ({
            payload: schedule,
            meta: { today: todayDateKey() },
        }),
    },
};
